export class ChartModel {
cstmExchange : any;
cstmProduct : any;
setValue(res){
if(res){
if(res['cstmExchange']){this.cstmExchange = res['cstmExchange'];}
if(res['cstmProduct']){this.cstmProduct = res['cstmProduct'];}
}
}
}